// 
export const IMPORT_RATEQUOTE_LIST = 'IMPORT_RATEQUOTE_LIST';
export const IMPORT_RATEQUOTE_PAGINATION = 'IMPORT_RATEQUOTE_PAGINATION';
export const IMPORT_RATEQUOTE_SUMMARY = 'IMPORT_RATEQUOTE_SUMMARY';